'use client';

import { useState, useEffect, useCallback } from 'react';

export interface PccResult {
  name: string;
  phone: string;
  birthdate: string;
  gender: string;
  carrier: string;
}

interface Props {
  verified: boolean;
  verifiedName: string | null;
  onVerified: (data: PccResult) => void;
}

export default function PccVerify({ verified, verifiedName, onVerified }: Props) {
  const [opening, setOpening] = useState(false);
  const [err, setErr] = useState('');

  const handleMessage = useCallback((e: MessageEvent) => {
    if (e.origin !== window.location.origin) return;
    const data = e.data as { type?: string; payload?: { success: boolean; message?: string; data?: PccResult } };
    if (!data || data.type !== 'PCC_RESULT') return;
    setOpening(false);
    if (data.payload?.success && data.payload.data) {
      onVerified(data.payload.data);
    } else {
      setErr(data.payload?.message || '본인인증에 실패했습니다.');
    }
  }, [onVerified]);

  useEffect(() => {
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);

  const openPcc = () => {
    setErr('');
    setOpening(true);
    window.open('/api/pcc/request', 'pcc_popup', 'width=420,height=640,scrollbars=yes');
  };

  if (verified) {
    return <p className="text-xs text-green-600">✓ 실명인증 완료{verifiedName ? ` (${verifiedName})` : ''}</p>;
  }

  return (
    <div>
      <button type="button" onClick={openPcc} disabled={opening}
        className="text-xs bg-sky-100 border border-sky-200 rounded px-3 py-1.5 text-sky-700 hover:bg-sky-200 disabled:opacity-50">
        {opening ? '인증창 확인 중...' : '실명인증 하기'}
      </button>
      {err && <p className="text-xs text-red-500 mt-1">{err}</p>}
    </div>
  );
}
